import axios from '@/plugins/axios'

export function getBoxs(params = {}) {
  return axios.get('box', {
    params,
  })
}

export function storeBox(data) {
  return axios.post('box', data)
}
export function settingBox(id, data) {
  return axios.put(`box/setting/${id}`, data)
}
export function settingMulBox(data) {
  return axios.put(`box/settingMul`, data)
}

export function unbindBox(id) {
  return axios.get('box/unbindBox/' + id)
}

export function getServerOptions() {
  return axios.get('box/getServerOptions')
}
export function getConfigs(params = {}) {
  return axios.get('box/queryConfig', {
    params,
  })
}

export function updateBoxRemark(id, data) {
  return axios.put(`box/updateRemark/${id}`, data)
}

export function getBoxWarningLogs(params = {}) {
  return axios.get('box/warningLogsIndex', {
    params,
  })
}
export function getWarningType(params = {}) {
  return axios.get('box/getWarningType', {
    params,
  })
}
